import { LeafletCircleMarker } from './models/leaflet-circle-marker.model';
import { LeafletPathComponent } from './../leaflet-path/leaflet-path.component';
import { Component, DoCheck, Input, IterableDiffers } from '@angular/core';

import * as L from 'leaflet';
import { LeafletBlockComponent } from '../leaflet-block-component.interface';

@Component({
    selector: 'leaflet-circle-marker',
    template: '',
    standalone: false
})
export class LeafletCircleMarkerComponent extends LeafletPathComponent implements LeafletBlockComponent, DoCheck {
	@Input() public name: string;
	@Input() public isDefault: boolean = true;
	@Input() public includeInOverlays: boolean = true;

	@Input() public tooltipHTML: string;

	//TODO: Figure out why `protected` doesn't work.
	public _data: LeafletCircleMarker[];
	@Input()
	public get data(): LeafletCircleMarker[] { return this._data; };
	public set data(value: LeafletCircleMarker[]) {
		this._data = value;

		this.updateLayerGroup();
	}

	//TODO: Figure out why `protected` doesn't work.
	public _layerGroup: any;

	public updateLayerGroup(additively: boolean = false): void {
		if (!this._layerGroup) {
			return;
		}

		if (!additively) {
			this._layerGroup.clearLayers();
		}

		let markers = [];

		for (let a = 0; a < this._data.length; a++) {
			const { latitude, longitude, ...options } = this._data[a];
		
			const circleMarker = L.circleMarker(
				[
					latitude,
					longitude
				],
				Object.assign({}, options)
			);

			let tooltip = options.tooltipHTML || this.tooltipHTML;

			if (tooltip) {
				circleMarker.bindTooltip(tooltip);
			}
			// <p>All Rights Reserved by Roima Intelligence.</p>
			let popup = L.popup().setContent(`<app-single-card>
			
		</app-single-card>`);

			circleMarker.bindPopup(popup);

			circleMarker.on(
				'mouseover',
				function(e) {
					

					
				}
			);

			circleMarker.on(
				'mouseout',
				function(e) {
					

					
				}
			);

			markers.push(circleMarker);
		}

		for (let a = 0; a < markers.length; a++) {
			this._layerGroup.addLayer(markers[a]);
		}
	}

	public initialize(layerGroup: L.LayerGroup, map: L.Map) {
		this._layerGroup = layerGroup;

		this.updateLayerGroup();
	}

	private iterableDiffer: any;

	constructor(private _iterableDiffers: IterableDiffers) {
		super();

    this.iterableDiffer = this._iterableDiffers.find([]).create(null);
	}

	ngDoCheck(): void {
		let changes = this.iterableDiffer.diff(this._data);
    
		if (changes) {
			

			this.updateLayerGroup();
		}
	}
}
